import React from "react";
import { Heart, Handshake, Users, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function PathwaysToInvolvement() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const pathways = [{
    title: "Donate",
    description: "Fuel our mission to expand economic opportunity. Your contribution directly supports Hispanic entrepreneurs, students, and future leaders across Colorado.",
    icon: Heart,
    theme: "gold",
    action: "Donate Now",
    href: "#donate"
  }, {
    title: "Sponsor",
    description: "Partner with us to create lasting impact. Sponsorship offers strategic visibility, alignment with community growth, and opportunities for corporate social responsibility.",
    icon: Handshake,
    theme: "navy",
    action: "Become a Sponsor",
    href: "#sponsor"
  }, {
    title: "Volunteer",
    description: "Give your time and talent to empower others. Mentor a student, support a community event, or join a committee to make a tangible difference.",
    icon: Users,
    theme: "white",
    action: "Sign Up to Volunteer",
    href: "#volunteer"
  }];
  return <section id="pathways-to-involvement" className="py-24 bg-background relative overflow-hidden">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold font-serif text-primary mb-6">
            Pathways to Involvement
          </h2>
          <p className="text-lg text-muted-foreground font-sans leading-relaxed">
            Choose your journey. Whether you give, partner, or serve, your commitment helps build a stronger, more prosperous community for everyone.
          </p>
        </div>

        <div ref={ref} className={cn("grid grid-cols-1 lg:grid-cols-3 gap-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {pathways.map((item, i) => <div key={i} data-index={i} className="h-full">
              <Card className={cn("h-full flex flex-col border-0 shadow-xl transition-transform duration-300 hover:-translate-y-2", item.theme === 'gold' && "bg-secondary text-secondary-foreground", item.theme === 'navy' && "bg-primary text-primary-foreground", item.theme === 'white' && "bg-card text-card-foreground border border-border/50")}>
                <CardHeader className="pb-4 pt-10 px-8">
                  <div className={cn("mb-6 p-4 rounded-2xl w-fit shadow-sm", item.theme === 'gold' && "bg-primary/10 text-primary", item.theme === 'navy' && "bg-white/10 text-secondary", item.theme === 'white' && "bg-secondary/20 text-primary")}>
                    <item.icon className="size-10" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-3xl font-serif font-bold mb-2">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-8 flex-grow">
                  <CardDescription className={cn("text-lg leading-relaxed", item.theme === 'gold' && "text-secondary-foreground/80", item.theme === 'navy' && "text-primary-foreground/80", item.theme === 'white' && "text-muted-foreground")}>
                    {item.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="px-8 pb-10 pt-6">
                  <Button asChild size="lg" className={cn("w-full text-base font-bold py-6 shadow-md transition-all", item.theme === 'gold' && "bg-primary text-primary-foreground hover:bg-primary/90", item.theme === 'navy' && "bg-secondary text-secondary-foreground hover:bg-secondary/90", item.theme === 'white' && "bg-primary text-primary-foreground hover:bg-primary/90")}>
                    <Link to={item.href}>
                      {item.action}
                      <ArrowRight className="ml-2 size-5" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}